//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isOdv: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    brand: function () {
      return this.item?.brand_name || ""
    },
    designName: function () {
      return this.item?.name || ""
    },
    materialName: function () {
      return this.item?.brand_material_name || ''
    },
    informationList: function () {
      return [
        {label: 'Показатели преломления 1,5', value: this.item?.['reflection_1,5'] || '-'},
        {label: 'Показатели преломления 1,53', value: this.item?.['reflection_1,53'] || '-'},
        {label: 'Показатели преломления 1,6', value: this.item?.['reflection_1,6'] || '-'},
        {label: 'Показатели преломления 1,67', value: this.item?.['reflection_1,67'] || '-'},
        {label: 'Показатели преломления 1,74', value: this.item?.['reflection_1,74'] || '-'}
      ]
      return [
        {label: Boolean(this.isOdv) ? 'Показатели преломления 1,5' : '&nbsp;', value: this.item?.['reflection_1,5'] || '-'},
        {label: Boolean(this.isOdv) ? 'Показатели преломления 1,53' : '&nbsp;', value: this.item?.['reflection_1,53'] || '-'},
        {label: Boolean(this.isOdv) ? 'Показатели преломления 1,6' : '&nbsp;', value: this.item?.['reflection_1,6'] || '-'},
        {label: Boolean(this.isOdv) ? 'Показатели преломления 1,67' : '&nbsp;', value: this.item?.['reflection_1,67'] || '-'},
        {label: Boolean(this.isOdv) ? 'Показатели преломления 1,74' : '&nbsp;', value: this.item?.['reflection_1,74'] || '-'}
      ]
    },

    link: function () {
      if (Boolean(this.isOdv)) {
        return `/lenses/${this?.item?.slug}`
      }
      return `/lenses/competitors/${this?.item?.slug}`
    },
  }

}
